export default {
  header: 'Emme voineet ladata tilaustasi',
  text: 'Tilauksesi valmistelussa tapahtui virhe. Ostoskorisi on turvassa — yritä uudelleen.',
  retry: 'Yritä uudelleen',
  address_header: 'Tarvitsemme toimitusosoitteesi',
  address_text: 'Emme voi laskea loppusummaa ennen kuin tiedämme, minne toimitetaan. Ostoskorisi on turvassa.',
  address_action: 'Lisää toimitusosoite',
  back_checkout: 'Takaisin tilaukseesi',
  back_basket: 'Takaisin ostoskoriin',
};
